import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './ModelVariantThresholds.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { initialModelVariantState } from '../../reducers/initialState';
import ModelVariantThresholdsListTable from './ModelVariantThresholdsListTable';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { compareValues } from '../../utils';
import Form from 'react-bootstrap/Form';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import Cookies from 'js-cookie';
import { useParams } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE, ModelCategoryPermission } from '../../constants';
import { getModelCategoryPermission } from '../../utils';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb';
import ModelVariantConfigurationContentTemplate from '../ModelVariantConfiguration/ModelVariantConfigurationContentTemplate';
import Pagination from '../Pagination/Pagination';


const FLOW_SEQUENCE = 'FLOW_SEQUENCE';
const SENSOR = 'SENSOR';

const ModelThresholdsList = ({
  getModelVariantThresholds,
  saveModelThreshold,
  describeModelThreshold,
  changeModelThreshold,
  setThresholdShowScreenStatus,
  modelManager,
  flowSequences,
  modelComponentPositions,
  thresholds = { ...initialModelVariantState.modelVariantManager.selectedModelVariant.Thresholds },
  intl,
  userProfileWidgets,
  userModelCategories,
  setCurrentPage,
  describeModel
}) => {
  let filter = thresholds.filter || '';
  let offset = thresholds.offset || 0;
  let limit = thresholds.limit || 1000;


  let { ModelCategoryId, ModelId, ModelVariantId } = useParams();

  const [currentEditId, setCurrentEditId] = useState(-1);
  const [currentFlowSequenceFilter, setCurrentFlowSequenceFilter] = useState(0);
  const [currentSensorFilter, setSurrentSensorFilter] = useState(0);
  const [active, setActive] = useState(false);
  const [thresholdVariantId, setThresholdVariantId] = useState(0);
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  useEffect(() => {
    if (ModelId && ModelCategoryId) {
      // Fetch model details if not already available
      if (!modelManager.selectedModel || modelManager.selectedModel.ModelId != ModelId) {
        describeModel(ModelId, ModelCategoryId);
      }
    }
  }, [ModelId, ModelCategoryId]);


  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };


  const disableModeHandler = status => {
    setThresholdShowScreenStatus(status);
  };
  const searchHandler = (type, value) => {
    let filteredList = thresholds.ThresholdsList;


    if (type === FLOW_SEQUENCE) {
      if (value > 0) {
        filteredList = filteredList.filter(function (item) {
          return item.SetpointId === value;
        });

      }
      if (currentSensorFilter > 0) {
        filteredList = filteredList.filter(function (item) {
          return item.ModelComponentPositionId === currentSensorFilter;
        });

      }
    }

    if (type === SENSOR) {
      if (value > 0) {
        filteredList = filteredList.filter(function (item) {
          return item.ModelComponentPositionId === value;
        });

      }
      if (currentFlowSequenceFilter > 0) {
        filteredList = filteredList.filter(function (item) {
          return item.SetpointId === currentFlowSequenceFilter;
        });
      }
    }

  };

  const filterData = () => {
    let filteredList = thresholds.ThresholdsList;
    if (currentSensorFilter > 0) {
      filteredList = filteredList.filter(function (item) {
        return item.ModelComponentPositionId === currentSensorFilter;
      });
    }

    if (currentFlowSequenceFilter > 0) {
      filteredList = filteredList.filter(function (item) {
        return item.SetpointId === currentFlowSequenceFilter;
      });
    }

    return filteredList;
  };



  useEffect(() => {
    getModelVariantThresholds(offset, limit, filter, ModelId, ModelVariantId, ModelCategoryId);
  }, [getModelVariantThresholds, offset, limit, filter, ModelId, ModelVariantId, ModelCategoryId]);


  const setEditHandler = modelThresholdId => {
    setCurrentEditId(modelThresholdId);
    if (modelThresholdId === -1) {
      changeModelThreshold({
        SelectedThreshold: {
          ...initialModelVariantState.modelVariantManager.selectedModelVariant.Thresholds.SelectedThreshold,
          ModelId: ModelId
        }
      });
      setThresholdShowScreenStatus(false);
    } else {
      setThresholdShowScreenStatus(true);
    }
  };

  const flowSequenceOptions = () => {
    let flowSequenceData = [];
    const initData = {
      label: <FormattedMessage id="common.filterAllStates" defaultMessage="All States" />,
      value: 0
    };
    flowSequences.forEach(element => {
      flowSequenceData.push({
        label: element.Name,
        value: element.SetpointId
      });
    });

    return [initData, ...flowSequenceData.sort(compareValues('label'))];
  };

  const modelComponentsOptions = () => {
    let modelComponentsData = [];
    const initData = {
      label: <FormattedMessage id="general.allComponents" defaultMessage="All Components" />,
      value: 0
    };
    const sensorComponents = modelComponentPositions.filter(item => item.NeedFeedback === true);
    sensorComponents.forEach(element => {
      modelComponentsData.push({
        label: element.Name,
        value: element.ModelComponentPositionId
      });
    });

    return [initData, ...modelComponentsData.sort(compareValues('label'))];
  };

  const onDropdownFilterFlowSequenceChange = e => {
    setCurrentFlowSequenceFilter(e.value);
    searchHandler(FLOW_SEQUENCE, e.value);
  };

  const onDropdownFilterSensorChange = e => {
    setSurrentSensorFilter(e.value);
    searchHandler(SENSOR, e.value);
  };

  const defaultThresholdHandler = (modelVariantThresholdId) => {
    setActive(true);
    setThresholdVariantId(modelVariantThresholdId);
  };

  const DefaultThreshold = () => {
    let saveData = thresholds.SelectedThreshold;
    saveData.PerformResetDefault = true;
    saveData.ModelId = ModelId;
    saveData.ModelCategoryId = ModelCategoryId;
    saveData.ModelVariantId = ModelVariantId;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    saveData.ModelVariantThresholdId = thresholdVariantId;
    saveModelThreshold(saveData, 'MODELVARIANTTHRESHOLDSEDIT');
  };

  const handleClose = () => {
    setActive(false);
    setThresholdVariantId(0);
  };

  const handleConfirm = () => {
    DefaultThreshold();
    handleClose();
  };

  let messageId = (thresholds && thresholds.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTTHRESHOLDSEDIT');

  const dialogTitle = intl.formatMessage({
    id: 'modelVariantThreshold.setDefaultConfirm',
    defaultMessage: 'Are you sure you want to set this threshold to default?'
  });

  let isOwner = getModelCategoryPermission(userModelCategories, ModelCategoryId, ModelCategoryPermission.Owner)
  const breadcrumbItems = [
    { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
    { label: <FormattedMessage id="model.models" defaultMessage="Models" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-list` },
    { label: <FormattedMessage id="model.modelvariant" defaultMessage="Model Variant" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variants-list` },
    { label: <FormattedMessage id="modelVariant.manageModelVariantThresholds" defaultMessage="Manage Model Variant Thresholds" /> } // Last item has no href (current page)
  ];

  const dataObj = Object.values(filterData());
  return (
    <div className={s.modelThreshold}>
      {thresholds.isLoading && <LoadingSpinner />}
      {thresholds.showBanner && (
        <Banner failureText={messageText} showBanner={thresholds.showBanner} status={thresholds.isOpSuccessful} successText={messageText} />
      )}
      <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
      <ModelVariantConfigurationContentTemplate selectedPage="manageModelVariantThresholds" userProfileWidgets={userProfileWidgets} intl={intl}>
        <div className={s.contentWrapper}>
          <div className={s.componentHeader}>
            <div className={s.subHeading}>
              <FormattedMessage id="modelVariant.manageModelVariantThresholds" defaultMessage="Manage Model Variant Thresholds" />
              <span className={s.circle}>
                {thresholds.ThresholdsList.length}
              </span>
            </div>
          </div>
          <div className='pb-3'>
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <Row className={s.topAndSideOnlyRow}>
            <Col sm={12}>
              <Form.Label>
                <FormattedMessage id="common.filterBy" defaultMessage="Filter By" />
              </Form.Label>
            </Col>
          </Row>
          <Row className={s.topRow}>
            <Col sm={6} lg={4}>
              <Row>
                <Col sm={6}>
                  <Dropdown
                    id="filterFlowSequence"
                    dataArray={flowSequenceOptions()}
                    controlData={{
                      placeholderText: <FormattedMessage id="general.allSequences" defaultMessage="All Sequences" />,
                      customClassName: ''
                    }}
                    disabled={thresholds.showAddEditScreen}
                    onDropdownChange={onDropdownFilterFlowSequenceChange}
                    selectedOption={flowSequenceOptions().filter(option => option.value === currentFlowSequenceFilter)}
                    data-unittest="filterFlowSequence"
                  />
                </Col>
                <Col sm={6}>
                  <Dropdown
                    id="filtersensor"
                    dataArray={modelComponentsOptions()}
                    controlData={{
                      placeholderText: <FormattedMessage id="general.allComponents" defaultMessage="All Components" />,
                      customClassName: ''
                    }}
                    disabled={thresholds.showAddEditScreen}
                    onDropdownChange={e => onDropdownFilterSensorChange(e)}
                    selectedOption={modelComponentsOptions().filter(option => option.value === currentSensorFilter)}
                    data-unittest="filtersensor"
                  />
                </Col>
              </Row>
            </Col>
            <Col sm={6} lg={8}>

            </Col>
          </Row>

          <div>
            <Pagination
              data={dataObj}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={thresholds.currentPage}>
              <ModelVariantThresholdsListTable
                setEditHandler={setEditHandler}
                defaultThresholdHandler={defaultThresholdHandler}
                selectedModelThresholdId={currentEditId}
                selectedModelId={ModelId}
                selectedModelVariantId={ModelVariantId}
                selectedModelCategoryId={ModelCategoryId}
                saveModelThreshold={saveModelThreshold}
                modelThreshold={thresholds}
                describeModelThreshold={describeModelThreshold}
                changeModelThreshold={changeModelThreshold}
                modelComponentPositions={modelComponentPositions}
                UpdateAllowed={isUpdateAllowed}
                disableMode={thresholds.showAddEditScreen}
                disableModeHandler={disableModeHandler}
              />
            </Pagination>
          </div>

        </div>
      </ModelVariantConfigurationContentTemplate>
    </div>
  );
};

ModelThresholdsList.propTypes = {
  describeModelThreshold: PropTypes.func.isRequired
};

export default injectIntl(ModelThresholdsList);
